import React from "react";
import { Link } from "react-router-dom";
import { Col, Button } from "reactstrap";

const InboxSidebar = ({
  isPrimaryTabActive,
  selectedIds,
  handleDeleteSelected,
  openDeleteAllModal,
}) => {
  return (
    <React.Fragment>
      <Col xl={3} className="mb-4 mb-xl-0">
        <div className="card h-100">
          <div className="card-body email-leftbar">
            {/* Compose Button */}
            <div className="d-grid mb-3">
              <Link to="/send-message" className="btn btn-danger btn-rounded">
                <i className="mdi mdi-plus me-2"></i>Compose
              </Link>
            </div>

            {/* Only show delete buttons for the “Primary” (Received) tab */}
            {isPrimaryTabActive && (
              <>
                <Button
                  color="danger"
                  className="mb-2 w-100"
                  onClick={handleDeleteSelected}
                  disabled={!selectedIds.length}
                >
                  Delete Selected
                </Button>

                <Button
                  color="warning"
                  className="w-100"
                  onClick={openDeleteAllModal}
                >
                  Delete All
                </Button>
              </>
            )}
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

export default InboxSidebar;
